/*eslint-disable no-mixed-operators */
/*eslint-disable array-callback-return */
/*eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { setSearchParams } from 'src/redux/admin/claimsSlice';
import { useDispatch, useSelector } from 'react-redux';
import EnrollmentTable from './EnrollmentTable';
import { EnrollmentData } from 'src/Member/components/dashboard/resources/dummyData';
import CustomPaginationItemsDisplay from '../../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../../common/pagination';
import {
  frameColumnsForSearchApproval,
  frameColumnsForAffilitionsApproval,
} from '../../../utils/common';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import Skeleton from '../../common/skeleton';

const EnrollmentList = ({
  activeTypeFilter,
  activeStatusFilter,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  data,
  totalRecords,
  dataFetching,
  isAPIFailed,
  isNotFound,
  selectedTabLocal,
  sortingParams,
  serverSideSorting,
}) => {
  const pageSizeHandler = (val) => {
    setPageSize(val.value);
    setCurrentPage(1);
  };

  const columnNames = useMemo(() => {
    const columns = frameColumnsForSearchApproval();
    if (activeStatusFilter !== 'allrequest') {
      return columns.filter((v) => v.accessor !== 'status');
    } else {
      return columns;
    }
  }, [activeStatusFilter]);

  const affiliationColumnNames = useMemo(() => {
    const affiliationColumns = frameColumnsForAffilitionsApproval();
    if (activeStatusFilter !== 'allrequest') {
      return affiliationColumns.filter((v) => v.accessor !== 'status');
    } else {
      return affiliationColumns;
    }
  }, []);

  const PaginationComponent = ({ showNumText }) => {
    return (
      <Col>
        <Row className="mb-4 align-items-center">
          <Col sm={6} className="pagination-display p-0">
            {totalRecords > pageSize ? (
              <CustomPaginationItemsDisplay
                pageSize={pageSize}
                setPageSize={pageSizeHandler}
                prefixMessage="Records per page"
                suffixMessage={
                  showNumText
                    ? `Showing ${pageSize * (currentPage - 1) + 1} - ${
                        pageSize * currentPage
                      } of ${totalRecords} results`
                    : null
                }
                //suffixMessage={showNumText ? showingRecordsMessage() : null}
              />
            ) : null}
          </Col>
          <Col sm={6} className="text-right mt-4 mt-md-0 p-0">
            <div className="claims-pagination float-right">
              {totalRecords > pageSize ? (
                <CustomPagination
                  pageSize={pageSize}
                  currentPage={currentPage}
                  totalCount={totalRecords}
                  onPageChange={(page) => {
                    console.log(page);
                    setCurrentPage(page);
                  }}
                />
              ) : null}
            </div>
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <>
      <div className="container-offset pt-4">
        {dataFetching && (
          <Skeleton count={10} height={40} className="plan-details-skeleton" />
        )}
        {data?.length === 0 && !dataFetching && !isNotFound && !isAPIFailed && (
          <div className="claims-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading={
                selectedTabLocal === 'affiliation'
                  ? 'No Affiliation request found!'
                  : 'No Enrollment request found!'
              }
              ErrorMessage={
                selectedTabLocal === 'affiliation'
                  ? 'We could not find any Affiliation request for the selected filter(s). Use another filter(s) and try again.'
                  : 'We could not find any Enrollment request for the selected filter(s). Use another filter(s) and try again.'
              }
            />
          </div>
        )}
        {data?.length === 0 && !dataFetching && isNotFound && (
          <div className="claims-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading={
                selectedTabLocal === 'affiliation'
                  ? 'No Affiliation request found!'
                  : 'No Enrollment request found!'
              }
              ErrorMessage={
                selectedTabLocal === 'affiliation'
                  ? 'We could not find any Affiliation request for the selected filter(s). Use another filter(s) and try again.'
                  : 'We could not find any Enrollment request for the selected filter(s). Use another filter(s) and try again.'
              }
            />
          </div>
        )}
        {data?.length === 0 && !dataFetching && isAPIFailed && !isNotFound && (
          <div className="claims-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
            />
          </div>
        )}
        {data?.length > 0 && !dataFetching && (
          <>
            <PaginationComponent showNumText={true} />
            <Col sm={12} className="p-0">
              {/*<div className="claims-list-grid" id="pdfdiv"> */}
              <div>
                <EnrollmentTable
                  className="account-table"
                  columns={
                    selectedTabLocal === 'affiliation'
                      ? affiliationColumnNames
                      : columnNames
                  }
                  data={data}
                  keyField={columnNames}
                  pageSizeCount={pageSize}
                  preserveData={[]}
                  dataFetching={dataFetching}
                  selectedTabLocal={selectedTabLocal}
                  sortingParams={sortingParams}
                  serverSideSorting={serverSideSorting}
                />
              </div>
            </Col>
            <PaginationComponent showNumText={false} />
          </>
        )}
      </div>
    </>
  );
};

export default EnrollmentList;
